const has = (v) => (Array.isArray(v) ? v.length > 0 : v != null && String(v).trim() !== "" && v !== 0);

// Fields a pro profile needs before approval.
export const PRO_REQUIRED = [
  ["Full name", (p) => p.full_name],
  ["Phone", (p) => p.phone],
  ["Category", (p) => p.category_id || p.category_name],
  ["Skills / subcategories", (p) => (p.subcategories?.length ? p.subcategories : p.skills)],
  ["City", (p) => p.city],
  ["Service cities", (p) => p.service_cities],
  ["Years of experience", (p) => p.years_experience],
  ["About me", (p) => p.about_me || p.about || p.bio],
  ["Profile photo", (p) => p.profile_image_url],
  ["KYC ID type", (p) => p.kyc?.id_type],
  ["KYC ID number", (p) => p.kyc?.id_number],
  ["KYC document", (p) => (p.kyc?.id_doc_urls?.length ? p.kyc.id_doc_urls : p.kyc?.id_doc_url)],
  ["Portfolio", (p) => p.portfolio],
];

export const proCompletion = (p) => {
  const missing = PRO_REQUIRED.filter(([, get]) => !has(get(p))).map(([label]) => label);
  return { pct: Math.round(((PRO_REQUIRED.length - missing.length) / PRO_REQUIRED.length) * 100), missing };
};
